// Configuration settings for the webchat application
import { useState, useEffect } from "react";
import { APP_VERSION, getVersionedUrl } from "./utils/version";
const API_URL = process.env.REACT_APP_API_URL;
const REACT_URL = process.env.REACT_APP_REACT_URL;


// Initial empty configuration
const initialConfig = {
  API_BASE_URL: API_URL,
  REACT_BASE_URL: REACT_URL,
  BOTS: [],
  LOGO: "",
  UI_CONFIG: {
    notificationDuration: 5000,
    defaultTheme: "light",
    animationsEnabled: true,
    version: APP_VERSION,
  },
};

// Hook to fetch and use configuration
export function useConfig() {
  const [config, setConfig] = useState(initialConfig);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [responseText, setResponseText] = useState("");

  useEffect(() => {
    async function fetchConfig() {
      // Use a fallback API URL if not set in config yet
      const apiUrl = `${config.REACT_BASE_URL}/backend`
      //console.log(`API URL: ${apiUrl}`);
      try {
        //console.log(`Fetching config from 1234: ${apiUrl}/api/config/frontend`);

        // Fetch configuration from the backend
        const response = await fetch(`${apiUrl}/api/config/frontend`);

        // Store the raw response text for debugging
        const text = await response.text();
        setResponseText(text);

        if (!response.ok) {
          throw new Error(`Failed to fetch configuration: ${response.status}`);
        }

        // Try to parse the response as JSON
        let data;
        try {
          data = JSON.parse(text);
        } catch (parseError) {
          throw new Error(
            `Invalid JSON response: ${
              parseError.message
            }. Response starts with: ${text.substring(0, 50)}...`
          );
        }

        //console.log("Received config data:", data);

        // Update the configuration with received data
        setConfig({
          API_BASE_URL: data.api_base_url || apiUrl,
          REACT_BASE_URL: data.react_base_url || "",
          BOTS: data.bots || [],
          LOGO: data.logo || "",
        });

        setLoading(false);
      } catch (err) {
        //console.error("Error fetching configuration:", err);
        setError(err);
        setLoading(false);
      }
    }

    fetchConfig();
  }, []);
  const getVersionedAssetUrl = (path) => {
    return getVersionedUrl(`${config.REACT_BASE_URL}/serve/${path}`);
  };

  return { config, loading, error, responseText,getVersionedAssetUrl };
}

// Export the hook as the primary way to access config
export default useConfig;

// For backward compatibility, also export default values
export const API_BASE_URL = initialConfig.API_BASE_URL;
export const REACT_BASE_URL = initialConfig.REACT_BASE_URL;
export const LOGO = "";
